export const dateFormat = (date: string, withHour = false): string => {
  if (withHour) {
    const dateHourPart = date.split('T');
    const datePart = dateHourPart[0].split('-');
    const hourPart = dateHourPart[1].split('.');
    return `${datePart[2]}/${datePart[1]}/${datePart[0]} ${hourPart[0]}`;
  }
  const datePart = date.split('-');
  return `${datePart[2]}/${datePart[1]}/${datePart[0]}`;
}

export function generateUniqueId() {
  // Crie um timestamp como base
  const timestamp = new Date().getTime();

  // Gere um número aleatório entre 0 e 999999
  const randomNumber = Math.floor(Math.random() * 1000000);

  // Combine o timestamp e o número aleatório para criar o ID único
  return `${timestamp}${randomNumber}`;
}

export const extractDateFormat = (date: string): string => {
  const dateHourPart = date.split('T');
  const datePart = dateHourPart[0].split('-');
  return `${datePart[2]}/${datePart[1]}/${datePart[0]}`;

}
export const extractHourFormat = (date: string): string => {

  const dateHourPart = date.split('T');
  const hourPart = dateHourPart[1].split('.');
  return `${hourPart[0]}`;


}


export default dateFormat;